/* eslint-disable @typescript-eslint/no-unused-vars */
import { AuthMode, BiometricType } from '@ionic-enterprise/identity-vault';
import { authentication, identityService } from '../../services/vault';

export interface AuthModePayload {
  authMode: AuthMode;
  biometricType: BiometricType;
  hasSession: boolean;
}

export interface AuthPayload {
  email: string;
  password: string;
}

export interface LoginPayload {
  success: boolean;
}

export interface PINPayload {
  pin: string;
}

export interface SessionPayload {
  email?: string | null;
}

export interface SettingsPayload {
  authMode?: AuthMode;
  biometricsAvailable?: boolean;
  biometricType?: BiometricType;
}

// export const login = (payload: AuthPayload) => {
//   return async (dispatch: any) => {
//     dispatch(loggingIn());
//     const res = await authentication.login(payload.email, payload.password);
//     if (res.success) {
//       await identityService.login({ username: res.user!.email, token: res.token! });
//       dispatch(sessionSet({ email: res.user!.email }));
//     }
//     dispatch(loadAuthMode());
//     return dispatch(loginSuccess({ success: res.success }));
//   }
// };

// export const logout = () => {
//   await authentication.logout();
//   await identityService.logout();
//   sessionCleared();
//   loadAuthMode();
//   return logoutSuccess();
// }

export const unlock = async () => {
  if (await identityService.restoreSession()) {
    return loadAuthMode();
  }
};

// unused code below
// export const updateAuthMode = async (authMode: AuthMode) => {
//   await identityService.setAuthMode(authMode);
//   return loadAuthMode();
// };

// unused code below
// export const load = async () => {
//   const email = await identityService.getEmail();
//   console.log(email);
//   loadAuthMode();
//   return ({ email });
// };

export const loadAuthMode = async () => {
  const authMode = await identityService.getAuthMode();
  const biometricType = await identityService.getBiometricType();
  const hasSession = await identityService.hasStoredSession();
  const biometricsSupported = await identityService.isBiometricsSupported();
  return { authMode, biometricType, hasSession, biometricsSupported };
};
